import React from 'react';
import '../css/home.css';

export default function Home() {
  return (
    <div className="homeContainer">
      <h2>Welcome to Cool Math Calculator!</h2>
      <p>
        There is no place for speculation. Whenever
        you try to prove something in maths, you need
        evidence. I personally believe that this is
        something which should be applied in other
        aspects of life as well… imagine the number
        of misunderstandings which could be prevented
        if visual/auditory evidence had to be provided!
      </p>
      <br />
      <p>
        So what are you waiting les&apos;t do some
        calculation to prove our answers.
      </p>
    </div>
  );
}
